// extracted by mini-css-extract-plugin
module.exports = {"container":"kQ","title":"kR","button":"kS","description":"kT","input":"kU","invalid":"kV","suggestion":"kW","reenterButton":"kX"};